package com.milta.core.localization.translations.es

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Sube un archivo de entregas y asígnalo a un conductor",
    stepImport = "Importar",
    stepVerifyAssign = "Verificar y asignar",
    stepValidateSend = "Validar y enviar las rutas",
    dropzoneTitle = "Arrastra y suelta tu archivo de entregas",
    dropzoneOrPrefix = "o",
    browseFilesLink = "explora tus archivos",
    browseFilesButton = "Explorar archivos",
    constraintsLabel = "Excel (.xlsx, .xls) o CSV · máx. 500 paradas · 10 MB",
    expectedColumnsEyebrow = "Columnas esperadas en el archivo",
    columnRecipientName = "Nombre del destinatario",
    columnAddress = "Dirección completa",
    columnDeadline = "Hora límite",
    columnPhone = "Teléfono",
    requiredPillLabel = "Obligatorio",
    optionalPillLabel = "Opcional",
    analysingLabel = "Analizando…",
    invalidFileTitle = "Archivo ilegible o formato no compatible",
    invalidFileMessage = "«%s» no se pudo analizar. Usa un archivo Excel (.xlsx, .xls) o CSV que respete las columnas esperadas.",
    chooseAnotherFileButton = "Elegir otro archivo",
    extractionFailedTitle = "No se pudieron extraer las entregas",
    extractionFailedMessage = "El archivo «%s» se leyó pero no se encontró ninguna fila utilizable. Verifica que contenga las columnas esperadas.",
    serviceUnavailableTitle = "Servicio de análisis temporalmente no disponible",
    serviceUnavailableMessage = "No podemos analizar tu archivo en este momento. Vuelve a intentarlo en unos instantes.",
    retryButton = "Reintentar",
    fileImportedStatus = "Archivo importado",
    stopsDetectedSuffix = "paradas detectadas",
    replaceFileLink = "↺ Reemplazar",
    assignToEyebrow = "Asignar a",
    selectDriverRequiredError = "Selecciona al menos un conductor antes de enviar la ruta.",
    selectedDriversCountSuffix = "conductores seleccionados",
    optimizeRouteButton = "Optimizar la ruta",
    tableCaptionLead = "Verifica y corrige las paradas antes de enviar",
    tableCaptionHint = "Haz clic en el lápiz para corregir una fila",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Nombre destinatario",
    columnHeaderAddress = "Dirección",
    columnHeaderPhone = "Teléfono",
    columnHeaderDeadline = "Hora límite",
    dashPlaceholder = "—",
    freeFormatBanner = "Formato libre detectado — las columnas no se pudieron reconocer automáticamente, verifica cada fila antes de enviar.",
    incompleteStopsBannerSuffix = "paradas incompletas — falta el nombre o la dirección, corregir antes del envío.",
    rowFlagMissingName = "⚠ falta el nombre",
    rowFlagMissingAddress = "⚠ falta la dirección",
    alreadyDispatchedBanner = "Esta ruta ya se envió a un conductor — actualiza la página para reiniciar con una nueva importación.",
    routeNotFoundError = "Ruta no encontrada. Actualiza la página e inténtalo de nuevo.",
    validationErrorGeneric = "Verifica la información introducida.",
    submitServerError = "Se produjo un error. Inténtalo de nuevo.",
    submitOptimizationUnavailableError = "Servicio de optimización temporalmente no disponible. La ruta no se creó — vuelve a intentarlo en unos instantes.",
    sendWithoutOptimizationButton = "Enviar sin optimización",
    dispatchSuccessMessage = "Ruta enviada correctamente a %s",
    dispatchSuccessBatchMessage = "Rutas enviadas correctamente a %d conductores",
    tooManyStopsError = "Este archivo contiene más de 500 entregas. Divídelo antes de importarlo.",
    resultHeaderMiddle = "entregas repartidas entre",
    resultDriverSingularSuffix = "conductor",
    resultDriverPluralSuffix = "conductores",
    resultDistanceLabel = "Distancia",
    resultDurationLabel = "Duración estimada",
    resultMetricNotCalculatedLabel = "No calculada",
    resultStopsChipSuffix = "paradas",
    resultMoreStopsTemplate = "+ %d paradas más",
    resultStopsLoadError = "No se pudieron cargar las paradas de esta ruta.",
    resultDispatchButton = "Validar y enviar las rutas",
)
